<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="currentChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="mediateDetail(scope.row)">案件详情</el-dropdown-item>
            </template>
            <template slot="case_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.case_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.case_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="zhcai_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.zhcai_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.zhcai_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="user_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.user_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.user_name }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="signers_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signers_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signers_txt }}</p>
                </el-tooltip>
            </template>
            <template slot="tijiao_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.tijiao_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.tijiao_time }}</p>
                </el-tooltip>
            </template>
            <template slot="lian_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.lian_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.lian_time }}</p>
                </el-tooltip>
            </template>
            <template slot="jie_an_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.jie_an_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.jie_an_time }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { mediateList } from '../../../api/mediateCase';

    export default {
        name: 'beMediated',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                data: [],
                option: {
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 150,  //操作栏宽度设置
                    column: [
                        {
                            label: '案件编号',
                            prop: 'case_sn'
                        }, {
                            label: '仲裁案号',
                            prop: 'zhcai_sn'
                        }, {
                            label: '申请人',
                            prop: 'user_name'
                        }, {
                            label: '合同名称',
                            prop: 'doc_title',
                        }, {
                            label: '合同编号',
                            prop: 'contract_sn'
                        }, {
                            label: '合同类型',
                            prop: 'product_name'
                        }, {
                            label: '被申请人',
                            prop: 'signers_txt',
                        }, {
                            label: '代理人',
                            prop: 'lawyer_name',
                        }, {
                            label: '案件状态',
                            prop: 'status_txt',
                        }, {
                            label: '提交案件时间',
                            prop: 'tijiao_time'
                        }, {
                            label: '立案时间',
                            prop: 'lian_time'
                        }, {
                            label: '结案时间',
                            prop: 'jie_an_time'
                        }
                    ]
                }
            };
        },
        methods:{
            //调解详情
            mediateDetail(row){
                this.$router.push({path:'/mediateCaseDetail',query:{id:row.id}})
            },
            currentChange(num){
                var obj = {
                    req_type: 1,
                    limit: 10,
                    page: num
                };
                mediateList(obj).then(res => {
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                    }
                });
            }
        },
        created() {
            var obj = {
                req_type: 1,
                limit: 10,
                page: 1
            };
            mediateList(obj).then(res => {
                if (res.code==200){
                    this.data=res.data.list
                    this.page.total=res.data.count
                    this.page.currentPage=1
                }
            });
        }
    };
</script>

<style scoped>
    .custom{
        background-color: #3e62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
